import React, { useContext } from 'react';

const ModalDialogPortalWrapperContext = React.createContext<null | HTMLDivElement>(null);

export const useModalDialogPortalWrapperContext = () => useContext(ModalDialogPortalWrapperContext);

export default ModalDialogPortalWrapperContext;
